import { PlannerConfig, ConfigOptions, FeatureConfig } from '../@types';
import billyCatalog from '@inter-ikea-storageone/range-billy/data/catalog.json';
import billyTemplate from '@inter-ikea-storageone/range-billy/data/template.json';
import platform from 'rangeConfig/shared/utils/platform';
import MeasureAction from 'components/SceneMenu/actions/MeasureAction';
import { billyComponentResolver } from '@inter-ikea-storageone/range-billy';
import { plannerComponentResolver } from '@inter-ikea-storageone/range';
import frames from './productGroups/frames';
import interiors from './productGroups/interiors';
import doors from './productGroups/doors';
import DoorsAction from 'components/SceneMenu/actions/DoorsAction';
import { ToggleDoorsFeature as ToggleDoors } from 'rangeConfig/shared/features/ToggleHingeDoors';
import sprToVpcMap from '@inter-ikea-storageone/range-billy/data/spr2vpc.json';
import { BillyCornerStabilityFeature } from './features/BillyCornerStability/BillyCornerStabilityFeature';
import billyLandingPageConfig from './billyLandingPageConfig';
import { DistanceMeasurementFeature } from 'rangeConfig/shared/features/DistanceMeasurementFeature';
import { getOptimizedModels } from 'rangeConfig/shared/utils/optimizedModels';
import { MultiWallSeeThroughFeature } from 'rangeConfig/shared/features/MultiWallSeeThroughFeature';
import { AddDoorsUpAndDownFeature } from './features/AddDoorsUpAndDownFeature';
import { AddMultipleFrameExtensionsFeature } from './features/AddMultipleFrameExtensionsFeature';

const defaultAssetsPath = '/assets/';
const assetsPath = import.meta.env.REACT_APP_ASSETS_PATH || defaultAssetsPath;
const screensaverPath = `${assetsPath}screensaver/screensaver_BILLY.mkv`;

const features = (): { mobile: FeatureConfig[]; desktop: FeatureConfig[] } => {
  return {
    mobile: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'ToggleDoors', feature: ToggleDoors },
      { id: 'BillyCornerStability', feature: BillyCornerStabilityFeature },
      { id: 'AddDoorsUpDown', feature: AddDoorsUpAndDownFeature },
      { id: 'AddMultipleFrameExtensions', feature: AddMultipleFrameExtensionsFeature }
    ],
    desktop: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'ToggleDoors', feature: ToggleDoors },
      { id: 'BillyCornerStability', feature: BillyCornerStabilityFeature },
      { id: 'DistanceMeasurement', feature: DistanceMeasurementFeature },
      { id: 'AddDoorsUpDown', feature: AddDoorsUpAndDownFeature },
      { id: 'AddMultipleFrameExtensions', feature: AddMultipleFrameExtensionsFeature }
    ]
  };
};

const productGroups: any = () => {
  const productGroups = {
    desktop: [frames, doors, interiors],
    mobile: [frames, doors, interiors]
  };

  return productGroups[platform].map(group => group());
};

const sceneActions = {
  desktop: [MeasureAction, DoorsAction],
  mobile: [DoorsAction, MeasureAction]
};

const billyPlannerConfig = (options?: ConfigOptions): PlannerConfig => {
  return {
    productCatalogs: [
      {
        name: 'billy',
        catalog: getOptimizedModels(billyCatalog),
        template: billyTemplate,
        assetsPath
      }
    ],
    sprToVpcMap,
    componentResolvers: [plannerComponentResolver, billyComponentResolver],
    featureToggles: [],
    productGroups: productGroups(options),
    features: features()[platform],
    screensaverPath: screensaverPath,
    cameraBehavior: () => {},
    sceneActions: sceneActions[platform],
    landingPageConfig: billyLandingPageConfig,
    roomOptions: { dimensions: { width: 5000, height: 2750, depth: 4000 } }
  };
};

export default billyPlannerConfig;
